// src/api/reportsService.ts
import apiClient from './config';
import { ReportData, ReportDetailResponse } from '../types/interfaces';
import i18next from 'i18next';

export const getReports = async (
  currency: string = 'USD'
): Promise<ReportData[]> => {
  try {
    const response = await apiClient.get('/reports', {
      params: { currency },
    });
    
    return response.data.reports.map((report: any) => ({
      id: String(report.id),
      created_at: report.created_at || '',
      payment_date: report.payment_date || '',
      access_type: report.access_type || '',
      progress: report.progress || 0,
      price: report.price || 0,
      risk: report.risk || 0,

      discounted_price: report.discounted_price ?? null,
      discount_percentage: report.discount_percentage ?? 0,
      expires_at: report.expires_at ?? null,

      num_filtraciones: report.len_data_breaches || 0,
      num_dominios_spoofeables: report.len_spoofeable_domains || 0,
      num_emails: report.len_emails || 0,
      num_ips: report.len_ips || 0,
      num_subdomains: report.len_subdomains || 0,
      num_typosquatting: report.len_typosquatting || 0,
      num_urls_without_waf: report.len_urls_no_waf || 0,
      num_directories: report.len_directories || 0,
      len_dir_sensibles: report.len_sensible_directories || 0,
      num_technologies: report.len_technologies_url || 0,
      num_trabajadores: report.len_employees || 0,
      len_vulns: report.len_vulns || 0,

      company_name: report.company_name || '',
      company_logo_url: report.company_logo_url || null,
      organization_id: report.organization_id || null,
      state: report.state || '',
      domains: report.domains || [],
      urls: report.urls || [],
      summary_download_urls: report.summary_download_urls ?? {},
    }));
  } catch (error: any) {
    throw new Error(error.response?.data?.detail);
  }
};


export const getReportDetail = async (reportId: string): Promise<ReportDetailResponse> => {
  try {
    const lang = i18next.language || 'es';
    const response = await apiClient.get(`/reports/detail/${reportId}?lang=${lang}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.detail);
  }
};